import type { ChatMode } from '../components/chat/ActiveConversationContext';

/**
 * The chat mode after a nav click floats a maximized chat down beside the destination page.
 *
 * BOTH maximized sizes float to a panel: the side dock (`expanded`) and Symphony's `fullscreen`. Any
 * non-maximized mode (`bubble`, `panel`) is left untouched. `fullscreen` was originally omitted (it
 * postdates this transition), which left a fullscreen chat with an active conversation covering the
 * page it navigated to — the Settings screen opened behind the overlay (#12548822344).
 *
 * Pure so the contract is unit-testable; the live `floatChatIfMaximized` action delegates here.
 */
export function floatedMode(mode: ChatMode): ChatMode {
  return mode === 'expanded' || mode === 'fullscreen' ? 'panel' : mode;
}
